import { handleApiError } from '@/utils/utils'
import { getAxiosApiClientByUser } from './axiosInstance'

interface UpdateUserPayload {
  stripeCustomerId?: string
  firstName?: string
  lastName?: string
  avatarUrl?: string | null
  companyName?: string
  industry?: string
  numOfEmployees?: string
  aiUsageIntent?: string[]
  businessRole?: string
  dataStorageLocation?: string
}

export const getUserUsage = async () => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.get('/credit/my-usage')
    return response.data
  } catch (error) {
    console.error('Error fetching user usage:', error)
    return null
  }
}

export const getUserByEmail = async (email: string) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.get(`/user/get-by-email/${email}`)
    return response.data
  } catch (error: unknown) {
    console.error('Error getting user data:', error)
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred'
    }
  }
}

export const updateUserInfo = async (data: UpdateUserPayload) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.put('/user/update', data)
    return { success: true, data: response.data }
  } catch (error: unknown) {
    console.error('Error updating user info:', error)
    const message =
      error instanceof Error ? error.message : 'Failed to update user info'
    return { success: false, error: message }
  }
}

export const linkUserProvider = async (provider: Record<string, unknown>) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.post('/user/link-user-provider', provider)
    return response
  } catch (error) {
    handleApiError(error, 'Failed to link user provider')
  }
}

export interface UserIdentity {
  id: string
  user_id: string
  identity_data?: {
    [key: string]: unknown
  }
  identity_id: string
  provider: string
  created_at?: string
  last_sign_in_at?: string
  updated_at?: string
}

export const unlinkUserProvider = async (identity: UserIdentity) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.post(
      '/user/unlink-user-provider',
      identity
    )
    return { success: true, data: response.data }
  } catch (error: unknown) {
    console.error('Error unlinking user provider:', error)
    const message =
      error instanceof Error ? error.message : 'Failed to unlink user provider'
    return { success: false, unlinkError: message }
  }
}

export const deleteUser = async (email: string, reason: string) => {
  const payload = {
    data: {
      email,
      deletion_reason: reason
    }
  }

  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.delete('/user/delete-user', payload)
    return response.data
  } catch (error: unknown) {
    console.error('Error deleting user:', error)
    const message =
      error instanceof Error ? error.message : 'Failed to delete user'
    return { success: false, unlinkError: message }
  }
}

export const getMedia = async (agencyId: string) => {
  try {
    const apiClient = await getAxiosApiClientByUser()
    const response = await apiClient.get(`/user/media/${agencyId}`)
    return response.data
  } catch (error) {
    handleApiError(error, 'Failed to fetch media for agency')
  }
}

// export const linkUserProvider = async (provider:string) => {
//   try {
//     const response = await apiClient.put('/user/link-user-provider', provider);
//     return response.data;
//     // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   } catch (error: any) {
//     console.error('Error Linking user provider:', error);
//     if (error.response) {
//       throw new Error(
//         error.response.data?.detail?.replace(/401:|500:|404:/g, '') ||
//         'Failed to link user provider'
//       );
//     } else if (error.request) {
//       throw new Error('No response from server');
//     } else {
//       throw new Error(error.message || 'Something went wrong');
//     }
//   }
// };
